import { DailyForecastWrapperLazy } from './dailyForecastWrapperLazy';

const props = [];

export const DailyForecastWrapperDirective = reactDirective => reactDirective(DailyForecastWrapperLazy, props);
DailyForecastWrapperDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('dailyForecastWrapper', DailyForecastWrapperDirective);
